export const initTabs = () => {
  const tabsBlock = document.querySelector(".features__tabs");

  if (!tabsBlock) return;

  const tabsList = tabsBlock.querySelectorAll(".features__tab");

  tabsBlock.addEventListener("click", (event: Event) => {
    const { target } = event;
    const tabLink = target as HTMLElement;

    if (tabLink.closest("[data-link-tab]")) {
      tabsBlock.querySelector("button.--tablink-active")?.classList.remove("--tablink-active");

      tabLink.classList.add("--tablink-active");

      tabsList.forEach((tab) => {
        if (tab.getAttribute("data-tab") === tabLink.dataset.linkTab) {
          tab.classList.add("--tab-active");
        } else {
          tab.classList.remove("--tab-active");
        }
      });
    }
  });
};
